import { create } from 'zustand';
import { authAPI } from '../services/api';
import { useProjectStore } from './useProjectStore';

interface User {
  id: number;
  username: string;
  email: string;
  role: string;
  company: string;
  // 可见模块白名单 (导航 key 列表)。null / 空 = 不限制。后端 users.User.nav_whitelist,
  // 只读 —— 前端改不动它, 也不该试。
  nav_whitelist?: string[] | null;
}

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  loading: boolean;
  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
  fetchProfile: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: !!localStorage.getItem('access_token'),
  loading: false,

  login: async (username, password) => {
    set({ loading: true });
    try {
      const { data } = await authAPI.login(username, password);
      localStorage.setItem('access_token', data.access);
      localStorage.setItem('refresh_token', data.refresh);
      // 换账号 = 新会话, 不能继承上一个人选中的项目。
      // 必须走 clearProject() 而不是只删 localStorage: useProjectStore 的
      // currentProject 是**模块加载时**从 localStorage 读一次的, 之后删 key
      // 不会动内存里那份。只删 key 的后果是同一次页面加载内换账号, 侧栏还挂着
      // 上一个人的井名、直接跳进上一个人的项目 —— 两个账号都是成员时连
      // validateCurrentProject 都会放行, 更不会跳回选择页。
      useProjectStore.getState().clearProject();
      // 登录后立即获取用户信息
      const profile = await authAPI.profile();
      set({ user: profile.data, isAuthenticated: true, loading: false });
    } catch (err) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      set({ user: null, isAuthenticated: false, loading: false });
      throw err;
    }
  },

  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    useProjectStore.getState().clearProject();
    set({ user: null, isAuthenticated: false });
  },

  fetchProfile: async () => {
    try {
      const { data } = await authAPI.profile();
      set({ user: data });
    } catch {
      set({ user: null, isAuthenticated: false });
    }
  },
}));
